export default __webpack_public_path__ + "static/media/arrowDown.5dae9306.svg";